export const baseURL = process.env.REACT_APP_BASE_API_URL;
export const USERS_API_URL = process.env.REACT_APP_USERS_API_URL;
export const SURVEYS_API_URL = process.env.REACT_APP_SURVEYS_API_URL;
export const BUSINESS_API_URL = process.env.REACT_APP_BUSINESS_API_URL;
export const STAGING_TABLE = process.env.REACT_APP_STAGING_TABLE;
export const LAUNCH_URL = process.env.REACT_APP_COMPOSE_EQ_LAUNCHER_URL;
export const ACCOUNT_URL = process.env.REACT_APP_EQ_ACCOUNT_URL;